import { h } from 'preact';
import React, { Component } from 'react';
import Switch from './Switch';
import { makeText } from '../../../util';

export default class Accordion extends Component {
  state = {
    open: false
  }
  toggleAccordion = (e) => {
    if (e === undefined || ['stack-toggle', 'opener', 'pm-switch', 'slider', 'view-all'].some(cssClass => e.target.className.includes(cssClass))) return;
    const panel = this.panel;
    const open = !this.state.open;
    this.setState({ open }, () => {
      if (this.props.force) this.props.force();
    });
    if (!open) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + 'px';
    }
  }
  shouldComponentUpdate(nextProps, nextState) {
    const panel = this.panel;
    const open = nextState.open;
    if (panel && open) {
      setTimeout(() => {
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }, 150);
    }
  }
  render() {
    const { dev, name, description, content, selected, toggle, child, value, language, titleContent, vendors, plus, isCustom, locked, isApple, appleDataBrokerLetter, usePurModel } = this.props;
    const { open } = this.state;
    const Settings = this.props.settings || {};
    const accordionStyles = {
      ...Settings.accordionsSpacing,
      ...Settings.accordionsFont
    };
    const panelStyles = {
      ...Settings.panelSpacing,
      ...Settings.panelFont
    };

    let partialConsent = false;
    let checked;
    if (child === 'vendors') {
      const { legIntCategories, consentCategories, active, legInt } = value;
      if (legIntCategories.length && consentCategories.length) {
        partialConsent = Boolean(active) !== Boolean(legInt);
      };
      checked = Boolean(active) || Boolean(legInt);
    } else {      
      if (selected === 'li') {
        checked = value.legInt;
      } else if (selected === 'consent') {
        checked = value.active;
      } else {
        //if type is feature
        checked = value && (value.active || value.legInt);
      }
    }

    const toggleText = makeText(Boolean(dev), Settings, 'toggleText', language);
    const toggleOffText = makeText(Boolean(dev), Settings, 'toggleOffText', language);
    return (
      <div
        tabIndex="0"
        className={plus ? 'tcfv2-stack plus' : 'tcfv2-stack'}
        onKeyDown={(e) => e.keyCode === 13 && this.toggleAccordion(e)}
      >
        <div className={isCustom ? 'stack-row custom' : 'stack-row'} style={{ position: 'relative' }}>
          <div
            className={open ? 'accordion active' : 'accordion'}
            style={accordionStyles}
            onClick={this.toggleAccordion}
          >
            {plus ? (
              <span className="plus-minus">{open ? '-' : '+'}</span>
            )
              : (
                <span className={open ? 'chevron up' : 'chevron down'} />
              )}
            {open && !titleContent ? <b>{name}</b> : name}
            {isApple && <span className="legend-key apple-broker">{appleDataBrokerLetter}</span>}
            {titleContent ? titleContent : null}
          </div>
          {toggle && (
            <Switch
              type={Settings.toggleType}
              color={Settings.toggleColor}
              colorActive={Settings.toggleActiveColor}
              offColor={Settings.toggleOffColor}
              neutralColor={Settings.toggleNeutralColor}
              offActiveColor={Settings.toggleOffActiveColor}
              text={toggleText}
              offText={toggleOffText}
              toggle={toggle}
              child={child}
              vendors={vendors}
              value={value}
              locked={locked}
              legInt={selected === 'li' ? true : false}
              checked={checked}
              tabbable
              partialConsent={partialConsent}
              consentType={child === 'vendors' ? 'all' : null}
              dev={dev}
              settings={Settings}
              language={language}
              usePurModel={usePurModel}
            />
          )}
        </div>
        <div ref={c => this.panel = c} className="panel">
          <p style={{ ...panelStyles }}>
            {content ? React.cloneElement(content, { accordionOpen: open }) : description}
          </p>
        </div>
      </div>
    );
  }
}